import React from 'react';

type LegalSectionProps = {
  id: string;
  title: string;
  number?: string;
  children: React.ReactNode;
  className?: string;
};

const LegalSection: React.FC<LegalSectionProps> = ({
  id,
  title,
  number,
  children,
  className = '',
}) => (
  <section id={id} className={`legal-section ${className}`.trim()}>
    <div className="legal-section__heading">
      {number ? <span aria-hidden="true">{number}</span> : null}
      <h2>{title}</h2>
    </div>
    <div className="legal-section__body">{children}</div>
  </section>
);

export default LegalSection;
